<template>
  <div class="block-record-list">
      <img v-if="exclusiveSource === '233zhuanshu'" class="icon-link" src="@/assets/sakuraBox/icon-link.png" alt="">
      <div class="block-name">
          <img src="@/assets/sakuraBox/title-block-list.png" alt="">
      </div>
      <div class="type-list">
          <div @click="changeCheckTypeId(item.id,item.name)" class="tag-type" v-for="item in typeList" :key="item.id + item.name" :class="checkTypeId === item.id ? 'tag-type-active' : ''"><div class="tag-type-inside">{{item.name}}</div></div>
      </div>
      <div class="search-box">
          <div class="search-main">
              <input v-model="searchWord" placeholder="请输入存档名称" type="text">
          </div>
          <div class="btn-search active" @click="searchSukuraBox">搜索</div>
      </div>
      <div class="line"></div>
      <CardList @openLogin="openLogin" :loading="loading" :cardType="1" :dataList="dataList" @openPanel="openPanel"></CardList>
      <div v-if="!noMore && dataList.length !== 0 && !loading" class="btn-loading-more active" @click="loadMore">
          <van-loading v-show="btnLoading" size="16" text-size="0.14rem" class="loading-icon" color="#E33D72">加载中...</van-loading>
          <span v-show="!btnLoading" class="btn-loading-more-span">展开更多</span>
      </div>
      <div class="no-more" v-if="noMore && dataList.length !== 0 && !loading">
            到底啦~
      </div>
  </div>
</template>

<script>
import CardList from './CardList.vue'
import active from '@/utils/axios/index';
import config from "@/../config";
export default {
  components: {
      CardList
  },
  data() {
    return {
        loading: false,
        btnLoading: true,
        page:1,
        dataList:[],
        typeList:[],
        searchWord: '',
        checkTypeId: '',
        noMore: false,
        exclusiveSource: '' // 专属来源
    }
  },
  mounted(){
    this.sukuraBoxColumn();
    this.exclusiveSource = this.$route.query.source;
  },
  watch:{
    checkTypeId:function(val){
      this.page = 1
      this.noMore = false
      this.sukuraBox()
    }
  },
  methods:{
    openLogin(){
      this.$emit('openLogin')
    },
    changeCheckTypeId(id, name){
      this.$tea('event_sakura_box_home_type_click',{
        sakura_type_name:name,
        sakura_type_id: id,
        source: 'sakuraBoxApp'
      }) // 存档大全所有栏目的点击次数（包括固定的与自定义的）
      this.searchWord = ''
      this.checkTypeId = id
    },
    openPanel(type, id){
      this.$emit('openPanel',type, id)
    },
    loadMore(){
      this.page++;
      this.sukuraBox()
    },
    searchSukuraBox(){
      this.page = 1
      this.checkTypeId = this.typeList[0].id
      this.sukuraBox()
    },
    sukuraBox(){
      if(this.page === 1){
        this.loading = true
      }else{
        this.btnLoading = true
      }
      active.sukuraBox(config.SAKURA_BASE_URL +'/api/sakura', {
        type: this.checkTypeId,
        title: this.searchWord,
        page:this.page,
        pageSize:5
      }).then((res) => {
        this.$emit('changeMaskLoadingflag')
        setTimeout(()=>{
          this.loading = false
          this.btnLoading = false
        },100)
        if(res.return_code == 200 || res.code == 200){
          this.dataList = this.page === 1 ? res.data : [...this.dataList, ...res.data]
          if(res.data.length < 5){
            this.noMore = true
          }
        }else{
          this.$toast(res.return_msg || res.message || res.msg)
        }
      })
    },
    sukuraBoxColumn(){
      active.sukuraBoxColumn(config.SAKURA_BASE_URL +'/api/sakura/column', {}).then((res) => {
        if(res.return_code == 200 || res.code == 200){
          this.typeList = res.data
          this.checkTypeId = res.data[0] ? res.data[0].id : 1
        }else{
          this.$toast(res.return_msg || res.message || res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
    .block-record-list{
        background: #FFF6FB;
        width: 352px;
        margin: 0 auto;
        border:solid 1px #FA7CB5;
        border-radius: 9px;
        position: relative;
    }
    .icon-link{
        width: 251px;
        height: 19px;
        position: absolute;
        left: 50%;
        top: -3px;
        transform: translate(-50%,-50%);
        z-index: 2;
    }
    .block-name{
        width: 232px;
        height: 24px;
        margin: 17px auto 20px auto;
        background: url('~assets/sakuraBox/title-bg.png') no-repeat;
        background-size: 100% 18px;
        background-position: center bottom;
        position: relative;
    }
    .block-name img{
        width: 103px;
        height: 24px;
        margin: 0 auto;
        display: block;
    }
    .type-list{
        width: 324px;
        margin: 0 auto;
    }
    .tag-type{
        width: 73px;
        height: 32px;
        margin: 4px;
        background: #FFEBEE;
        text-align: center;
        line-height: 24px;
        border-radius: 6px;
        display: inline-block;
        color: #696969;
        font-size: 12px;
        padding: 3px;
    }
    .tag-type:active{
      transform: scale(0.9);
    }
    .tag-type-inside{
        border-radius: 5px;
        border: solid 1px #FBD3DD;
    }
    .tag-type-active{
        background: #FA7CB5;
        color: white;
    }
    .search-box{
        width: 318px;
        height: 32px;
        margin: 0 auto 14px auto;
        position: relative;
    }
    .search-main{
        width: 237px;
        height: 30px;
        border: solid 1px #FA7CB5;
        border-radius: 30px;
        padding: 7px 16px 6px 32px;
        font-size: 0;
        background: url('~assets/sakuraBox/icon-search.png') no-repeat;
        background-size: 12px 12px;
        background-position: center left 12px;
        margin-top: 8px;
    }
    .search-main input{
        background: none;
        border:none;
        line-height: 14px;
        font-size: 12px;
        color: #666666;
    }
    .btn-search{
        width: 68px;
        height: 32px;
        background: url('~assets/sakuraBox/btn-search.png') no-repeat;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 0;
        line-height: 32px;
        text-align: center;
        font-size: 12px;
        color: white;
    }
    .line{
        width: 331px;
        height: 1px;
        background-image: linear-gradient(to right, #E33D72 0%, #E33D72 50%, transparent 50%);
        background-size: 14px 1px;
        background-repeat: repeat-x;
        margin: 0 auto;
    }
    .active:active{
        transform: scale(0.9);
    }
    .btn-loading-more{
        width: 326px;
        background: white;
        height: 36px;
        line-height: 34px;
        border:solid 1px #FA7CB5;
        border-radius: 10px;
        margin: 0 auto 16px auto;
        text-align: center;
    }
    .btn-loading-more-span{
        display: inline-block;
        margin: 0 auto;
        padding-right: 18px;
        background: url('~assets/sakuraBox/icon-add.png') no-repeat;
        background-size: 0.11rem;
        background-position: right center;
        font-size: 12px;
        color: #555;
    }
    .no-more{
        color: #F967A4;
        text-align: center;
        font-size: 12px;
        margin-bottom: 20px;
    }
</style>
